import { IPosition } from '../../types/common.types';

type Grid = number[][];

function inBounds(grid: Grid, x: number, y: number): boolean {
  return y >= 0 && y < grid.length && x >= 0 && x < grid[0].length;
}

export function enforceBorder(grid: Grid, thickness: number): void {
  const h = grid.length;
  const w = grid[0].length;
  for (let t = 0; t < thickness; t++) {
    for (let x = 0; x < w; x++) {
      grid[t][x] = 0;
      grid[h - 1 - t][x] = 0;
    }
    for (let y = 0; y < h; y++) {
      grid[y][t] = 0;
      grid[y][w - 1 - t] = 0;
    }
  }
}

export function removeCorridorBlockingWalls(grid: Grid): void {
  const h = grid.length;
  const w = grid[0].length;
  for (let y = 1; y < h - 1; y++) {
    for (let x = 1; x < w - 1; x++) {
      if (grid[y][x] !== 0) {
        continue;
      }
      const top = grid[y - 1][x] === 1;
      const bottom = grid[y + 1][x] === 1;
      const left = grid[y][x - 1] === 1;
      const right = grid[y][x + 1] === 1;
      if ((top && bottom) || (left && right)) {
        grid[y][x] = 1;
      }
    }
  }
}

export function removeDisconnectedRegions(grid: Grid, seed: IPosition): void {
  const h = grid.length;
  const w = grid[0].length;
  const visited: boolean[][] = [];
  for (let y = 0; y < h; y++) {
    visited[y] = new Array<boolean>(w).fill(false);
  }
  const cardinals = [
    [0, -1],
    [0, 1],
    [-1, 0],
    [1, 0],
  ];
  const queue: IPosition[] = [seed];
  visited[seed.y][seed.x] = true;
  while (queue.length > 0) {
    const c = queue.shift() as IPosition;
    for (const [dx, dy] of cardinals) {
      const nx = c.x + dx;
      const ny = c.y + dy;
      if (!inBounds(grid, nx, ny) || visited[ny][nx] || grid[ny][nx] === 0) {
        continue;
      }
      visited[ny][nx] = true;
      queue.push({ x: nx, y: ny });
    }
  }
  for (let y = 0; y < h; y++) {
    for (let x = 0; x < w; x++) {
      if (grid[y][x] === 1 && !visited[y][x]) {
        grid[y][x] = 0;
      }
    }
  }
}

export function removeTinyWallPockets(grid: Grid): void {
  const h = grid.length;
  const w = grid[0].length;
  for (let y = 1; y < h - 1; y++) {
    for (let x = 1; x < w - 1; x++) {
      if (grid[y][x] !== 0) {
        continue;
      }
      let g = 0;
      for (let dy = -1; dy <= 1; dy++) {
        for (let dx = -1; dx <= 1; dx++) {
          if (dx === 0 && dy === 0) {
            continue;
          }
          if (grid[y + dy][x + dx] === 1) {
            g++;
          }
        }
      }
      if (g >= 7) {
        grid[y][x] = 1;
      }
    }
  }
}
